import React from 'react';
import cx from 'classnames';
import styles from './Choice.css?module';

const Radio = ({isSelected}) => (
  <div
    className={cx({
      [styles.radio]: true,
      [styles.radioSelected]: isSelected,
    })}
  />
);

const Checkbox = ({isSelected}) => (
  <div
    className={cx({
      [styles.checkbox]: true,
      [styles.checkboxSelected]: isSelected,
    })}
  />
);

const Choice = ({toggle, onClick, children}) => (
  <div className={styles.Choice} onClick={onClick} role="button">
    <div className={styles.label}>{children}</div>
    <div>{toggle}</div>
  </div>
);

export const RadioChoice = ({onClick, isSelected, children}) => (
  <Choice onClick={onClick} toggle={<Radio isSelected={isSelected} />}>
    {children}
  </Choice>
);

export const CheckboxChoice = ({onClick, isSelected, children}) => (
  <Choice onClick={onClick} toggle={<Checkbox isSelected={isSelected} />}>
    {children}
  </Choice>
);
